export default __webpack_public_path__ + "static/media/logo-color.75318ae8.svg";